if (!customElements.get('add-to-registry')) {
  customElements.define(
    'add-to-registry',
    class AddToRegistry extends HTMLElement {
      constructor() {
        super();
        this.sku = this.dataset.sku;
        this.price = this.dataset.price;
        this.category = this.dataset.category;
        this.title = this.dataset.title;
        this.image = this.dataset.image;
        this.url = this.dataset.url;
      }

      connectedCallback() {
        this.addEventListener('click', this.handleClick.bind(this));
        this.addEventListener('keydown', this.handleKeydown.bind(this));
      }

      handleKeydown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.handleClick();
        }
      }

      beforeAddToRegistry() {
          let currency = "USD"
          let trackingItemData = {
          item_name: this.title,
          item_id: this.sku,
          quantity: 1,
          price: this.price,
          currency: currency,
          item_brand: 'Juliska',
          category: this.category,
          affiliation: "Juliska Shopify Website",
          index: 0
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "add_to_registry",
            currency: currency,
            value: this.price,
            ecommerce: {
              items: [
                {
                  ...trackingItemData
                },
              ]
            }
        });
      }

      async handleClick () {
          if (!window.MyRegistrySDK) {
            console.error('Attempted to open My Registry modal, but MyRegistrySDK has not loaded yet.')
            return;
          }

          this.beforeAddToRegistry();
          const gift = {
            Title: this.title,
            ImageUrl: this.image.replace(/http(s*):/, ''),
            URL: this.url,
            Price: this.price / 100,
            Quantity: 1,
            SKU: this.sku,
            HideSize: true,
            HideColor: true,
          };

          try {
            const myRegistrysSDK = new window.MyRegistrySDK(gift);
            if (myRegistrysSDK) myRegistrysSDK.showPopup();
          } catch (error) {
            console.error(error);
          }
      }
    }
  );
}
